<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header d-flex align-items-center">
      <div class="card-title mb-0">
        {{ cardTitle }}
      </div>
      <button 
        v-if="dataRow"
        type="button"
        class="btn btn-outline-success btn-sm ms-auto"
        @click="recalculateBalance">
        <i class="fas fa-sync-alt me-1"></i> مراجعة المعاملات المالية
      </button>
    </div>
    
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <!-- Deleted Account Alert -->
    <div v-show="localDeleted" class="alert alert-danger ...">
      <div v-if="successRestore" class="alert alert-success mx-3 mt-3">
        <i class="fas fa-check me-2"></i>
        تم استعادة الحساب بنجاح
      </div>
      <div>
        <i class="fas fa-exclamation-triangle me-2"></i>
        <strong>تنبيه:</strong> هذا الحساب محذوف منذ {{ formatDate(dataRow.deletedAt) }}
      </div>
      <button 
        type="button" 
        class="btn btn-success btn-sm" 
        :disabled="restoreLoader"
        @click="restoreAccount">
        <span v-show="restoreLoader" class="spinner-border spinner-border-sm me-1"></span>
        <i v-show="!restoreLoader" class="fas fa-undo me-1"></i>
        استعادة الحساب
      </button>
    </div>

    <form @submit.prevent="subimtData()">
      <!--begin::Body-->
      <div class="card-body">
        <div class="row">
          <div class="col">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="user-tab" data-bs-toggle="tab" data-bs-target="#user-tab-pane" type="button" role="tab" aria-controls="user-tab-pane" aria-selected="true">بيانات العميل</button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="nafath-tab" data-bs-toggle="tab" data-bs-target="#nafath-tab-pane" type="button" role="tab" aria-controls="nafath-tab-pane" aria-selected="false">بيانات نفاذ</button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="banks-tab" data-bs-toggle="tab" data-bs-target="#banks-tab-pane" type="button" role="tab" aria-controls="banks-tab-pane" aria-selected="false">الحسابات البنكية</button>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade p-3 show active" id="user-tab-pane" role="tabpanel" aria-labelledby="user-tab" tabindex="0">

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">الصورة الشخصية:</label>
                    <div>
                      <img v-if="dataRow.avatar" :src="MEDIA_URL+dataRow.avatar" class="img-thumbnail" style="max-width: 200px;" alt="">
                    </div>
                    <div class="mt-2">
                      <input type="file" class="form-control" @change="setAvatarImg($event.target.files)" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">الاسم:</label>
                    <input type="text" class="form-control" v-model="name">
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">الرصيد الحالي:</label>
                      <div class="fw-bold text-success">
                        {{ formattedBalance }}
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">رقم الهوية:</label>
                    <div>{{ dataRow.identity }}</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">الجوال:</label>
                    <div>{{ dataRow.mobile }}</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">تفعيل رقم الجوال:</label>
                    <div>{{ (dataRow.mobileVerified)? 'نعم ، مفعّل' : 'لا ، غير مفعّل' }}</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">البريد الإلكتروني:</label>
                    <div>{{ dataRow.email }}</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">تفعيل البريد الإلكتروني:</label>
                    <div>{{ (dataRow.emailVerified)? 'نعم ، مفعّل' : 'لا ، غير مفعّل' }}</div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">التخصص:</label>
                    <select v-model="specialization" class="form-control" multiple>
                      <option v-for="sp in specializationList" :value="sp.id" :key="sp.id">{{ sp.name }}</option>
                    </select>
                  </div>
                </div>
                
                <!-- Commission Section -->
                <div class="row mt-2">
                  <div class="col-12 mb-3">
                    <div class="form-check form-switch">
                      <input 
                        class="form-check-input" 
                        type="checkbox" 
                        id="hasCustomCommission" 
                        v-model="hasCustomCommission"
                      >
                      <label class="form-check-label" for="hasCustomCommission">
                        تفعيل عمولة مخصصة لهذا المزود
                      </label>
                    </div>
                  </div>
                </div>
                <div v-if="hasCustomCommission" class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label class="form-label">نسبة عمولة مخصصة (%)</label>
                    <input 
                      type="number" 
                      class="form-control" 
                      v-model="customCommissionPercentage"
                      min="0"
                      max="100"
                      placeholder="أدخل النسبة المئوية"
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">حالة نفاذ:</label>
                    <div>{{ dataRow.nafathStatus }}</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">صورة الهوية:</label>
                    <div>
                      <img v-if="dataRow.identityImage" :src="MEDIA_URL+dataRow.identityImage" class="img-thumbnail" style="max-width: 200px;" alt="">
                    </div>
                    <div class="mt-2">
                      <input type="file" class="form-control" @change="setIdentityImg($event.target.files)" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">حالة تفعليل الهوية:</label>
                    <select v-model="identityAccepted" class="form-control">
                      <option :value="true">مفعلة</option>
                      <option :value="false">غير مفعلة</option>
                    </select>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">آخر تسجيل دخول:</label>
                    <div class="date-format">{{ (dataRow.lastLogin)? formatDate(dataRow.lastLogin) : '' }}</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">حالة الحظر:</label>
                    <select v-model="isBlocked" class="form-control">
                      <option :value="false">غير محظور</option>
                      <option :value="true">محظور</option>
                    </select>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">حالة الحساب:</label>
                    <select v-model="status" class="form-control">
                      <option :value="null">غير مُحدد</option>
                      <option v-for="(val, key) in statusObject" :value="key" :key="key">{{ val }}</option>
                    </select>
                  </div>
                </div>

              </div>
              <!-- Nafath -->
              <div class="tab-pane fade p-3" id="nafath-tab-pane" role="tabpanel" aria-labelledby="nafath-tab" tabindex="0">
                <div v-if="!dataRow.NafathProvider" class="row">
                  <div class="col">
                    <div class="alert alert-info">لم يتم الحصول على بيانات من قبل نفاذ</div>
                  </div>
                </div>
                <div v-else class="row">
                  <div class="col">
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">معرف المستخدم:</label>
                        <div>{{ dataRow.NafathProvider.nin }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">كود الجنسية:</label>
                        <div>{{ dataRow.NafathProvider.nationality }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">رقم إصدار الهوية:</label>
                        <div>{{ dataRow.NafathProvider.idVersionNumber }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">مكان إصدار الهوية:</label>
                        <div>{{ dataRow.NafathProvider.idIssuePlace }}</div>
                        <div>{{ dataRow.NafathProvider.iqamaIssuePlaceDesc }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">تاريخ إصدار الهوية - ميلادي:</label>
                        <div>{{ dataRow.NafathProvider.idIssueDateG }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">تاريخ إصدار الهوية - هجري:</label>
                        <div>{{ dataRow.NafathProvider.idIssueDate }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">تاريخ إنتهاء الهوية - ميلادي:</label>
                        <div>{{ dataRow.NafathProvider.idExpiryDateG }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">تاريخ إنتهاء الهوية - هجري:</label>
                        <div>{{ dataRow.NafathProvider.idExpiryDate }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">الجنس:</label>
                        <div>{{ dataRow.NafathProvider.gender }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">الاسم الاول:</label>
                        <div>{{ dataRow.NafathProvider.firstName }}</div>
                        <div>{{ dataRow.NafathProvider.englishFirstName }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">اسم العائلة:</label>
                        <div>{{ dataRow.NafathProvider.familyName }}</div>
                        <div>{{ dataRow.NafathProvider.englishLastName }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">اسم الاب:</label>
                        <div>{{ dataRow.NafathProvider.fatherName }}</div>
                        <div>{{ dataRow.NafathProvider.englishSecondName }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">اسم الجد:</label>
                        <div>{{ dataRow.NafathProvider.grandFatherName }}</div>
                        <div>{{ dataRow.NafathProvider.englishThirdName }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">تاريخ الميلاد:</label>
                        <div>{{ dataRow.NafathProvider.dateOfBirthG }}</div>
                        <div>{{ dataRow.NafathProvider.dateOfBirthH }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">الحالة الاجتماعية:</label>
                        <div>{{ (socialStatusCodeObj[dataRow.NafathProvider.socialStatusCode] && socialStatusCodeObj[dataRow.NafathProvider.socialStatusCode][dataRow.NafathProvider.gender])? socialStatusCodeObj[dataRow.NafathProvider.socialStatusCode][dataRow.NafathProvider.gender] : 'غير معروف' }}</div>
                        <div>{{ dataRow.NafathProvider.socialStatusDesc }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">تاريخ آخر سفر - خروج:</label>
                        <div>{{ dataRow.NafathProvider.lastTravelExitDateG }}</div>
                        <div>{{ dataRow.NafathProvider.lastTravelExitDate }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">تاريخ آخر سفر - دخول:</label>
                        <div>{{ dataRow.NafathProvider.lastTravelEntryDateG }}</div>
                        <div>{{ dataRow.NafathProvider.lastTravelEntryDate }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">محل الميلاد:</label>
                        <div>{{ dataRow.NafathProvider.placeOfBirth }}</div>
                        <div>{{ dataRow.NafathProvider.placeOfBirthDesc }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">رقم جواز السفر:</label>
                        <div>{{ dataRow.NafathProvider.passportNumber }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">رمز المهنة:</label>
                        <div>{{ dataRow.NafathProvider.occupationCode }}</div>
                        <div>{{ dataRow.NafathProvider.occupationDesc }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">عدد المعالين:</label>
                        <div>{{ dataRow.NafathProvider.totalNumberOfCurrentDependents }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">كود الجنسية:</label>
                        <div>{{ dataRow.NafathProvider.nationalityCode }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">الجنسية:</label>
                        <div>{{ dataRow.NafathProvider.nationalityDesc }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">العنوان الوطني:</label>
                        <div>{{ dataRow.NafathProvider.nationalAddress }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">قاصر:</label>
                        <div>{{ dataRow.NafathProvider.isMinor }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">رب الاسرة:</label>
                        <div>{{ dataRow.NafathProvider.hohInfo }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">قاصر:</label>
                        <div>{{ dataRow.NafathProvider.isMinor }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">اسم الكفيل:</label>
                        <div>{{ dataRow.NafathProvider.sponsorName }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">الوضع القانوني:</label>
                        <div>{{ dataRow.NafathProvider.legalStatus }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">الحالة الاجتماعية:</label>
                        <div>{{ dataRow.NafathProvider.socialStatus }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">الوضع القانوني:</label>
                        <div>{{ dataRow.NafathProvider.legalStatus }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">مؤشر الدخول والخروج:</label>
                        <div>{{ dataRow.NafathProvider.inOutIndecator }}</div>
                      </div>
                      <div class="col-12 col-sm-6 mb-3 pb-2 border-bottom">
                        <label for="" class="form-label">كود محل الميلاد:</label>
                        <div>{{ dataRow.NafathProvider.placeOfBirthCode }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Bank Accounts -->
              <div class="tab-pane fade p-3" id="banks-tab-pane" role="tabpanel" aria-labelledby="banks-tab" tabindex="0">
                <ProviderBanks :banks="dataRow.ProvidersBanks" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Body-->
      <!--begin::Footer-->
      <div class="card-footer">
        <div class="row">
          <div class="col text-end">
            <button v-if="!formLoader" type="submit" class="btn btn-success">ارسل</button>
            <loader v-if="formLoader" />
          </div>
        </div>
      </div>
      <!--end::Footer-->
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import { toast, formatDate } from '@/helpers/tools';
import { mapGetters } from 'vuex';
import ProviderBanks from '@/components/ProviderBanks.vue';

export default {
  name: 'ProvidersForm',
  components: { ProviderBanks },
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
    statusObject: {
      type: Object,
      default: {},
    },
    specializationList: {
      type: Array,
      default: [],
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      restoreLoader: false,
      socialStatusCodeObj: {
        '0': {M: 'اعزب', F: 'غير معروف'},
        '1': {M: 'زوجة واحدة', F: 'غير متزوجة'},
        '2': {M: 'زوجتين', F: 'متزوجه'},
        '3': {M: 'ثلاث زوجات', F: 'مطلقه'},
        '4': {M: 'أربع زوجات', F: 'أرمله'},
        '5': {M: 'غير معروف', F: 'مطلقة معلقة'},
      },
      name: '',
      isBlocked: false,
      status: null,
      specialization: [],
      localDeleted: false, 
      successRestore: false,
      hasCustomCommission: false,
      customCommissionPercentage: null,
      avatar: null,
      identityImage: null,
      identityAccepted: false,
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL']),
    formattedBalance(){
      if(!this.dataRow || this.dataRow.balance == null)
        return '0 ريال';

      return `${Number(this.dataRow.balance).toLocaleString()} ريال`;
    }
  },
  methods: {
    formatDate,
    async restoreAccount() {
      if (!this.dataRow?.id) return;

      this.restoreLoader = true;
      this.hasError = false;

      try {
        await this.$http.put(`/api/admin/providers/restore/${this.dataRow.id}`);

        this.successRestore = true;
        
        setTimeout(() => {
          this.successRestore = false;
          this.localDeleted = false; 
        }, 3000);

        this.$emit('restored');  

      } catch(err) {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      }

      this.restoreLoader = false;
    },
    subimtData(){
      this.formLoader = true;
      this.hasError = false;
      this.hasSucess = false;

      const payload = new FormData();
      payload.append('name', this.name);
      payload.append('isBlocked', this.isBlocked);
      payload.append('status', this.status);
      payload.append('specialization', this.specialization);
      payload.append('hasCustomCommission', this.hasCustomCommission);
      payload.append('customCommissionPercentage', this.hasCustomCommission ? (this.customCommissionPercentage || '') : '');
      payload.append('identityAccepted', this.identityAccepted);
      if(this.avatar)
        payload.append('avatar', this.avatar);
      if(this.identityImage)
        payload.append('identityImage', this.identityImage);
      
      let api = null;
      if(this.dataRow)
        api = this.$http.put(`/api/admin/providers/update/${this.dataRow.id}`, payload);
      else
        return false;
        // api = this.$http.post('/api/admin/providers/create', formData);
      api.then(({data}) => {
        if(false){
          toast('تم إضافة الإعلان بنجاح', 'success');
          this.$router.replace('/propertyDoc').catch(() => {});
        }else{
          this.message = 'تم التعديل بنجاح';
          this.hasSucess = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },

    recalculateBalance() {
      this.$swal.fire({
      title: 'هل تريد تعديل الرصيد؟',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'تأكيد',
      cancelButtonText: 'إلغاء',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.$swal.fire({
          title: 'جارٍ تحديث الرصيد...',
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        
        this.$http.get(`/api/admin/providers/recalculateBalance/${this.dataRow.id}`)
          .then(() => {
            this.$swal.fire('تم التحديث!', 'تم تحديث الرصيد بنجاح.', 'success');
            this.$emit('reloadProvider');
          })
          .catch(() => {
            this.$swal.fire('خطأ!', 'حدث خطأ أثناء تحديث الرصيد.', 'error');
          });
      }
    });
  },
  setAvatarImg(files){
    this.avatar = files[0] ?? null;
  },
  setIdentityImg(files){
    this.identityImage = files[0] ?? null;
  },
},
  created(){
    if(this.dataRow){
      this.name = this.dataRow.name;
      this.isBlocked = this.dataRow.isBlocked;
      this.status = this.dataRow.status;
      if(this.dataRow.MaintenanceIssues.length){
        for(let m=0; m<this.dataRow.MaintenanceIssues.length; m++){
          this.specialization.push(this.dataRow.MaintenanceIssues[m].id);
        }
      }
      this.localDeleted = !!this.dataRow.deletedAt;
      this.hasCustomCommission = this.dataRow.hasCustomCommission ?? false;
      this.customCommissionPercentage = this.dataRow.customCommissionPercentage ?? null;
      this.identityAccepted = this.dataRow.identityAccepted;
    }
  }
}
</script>